<template>
    <v-expansion-panels v-if="sources?.length">
        <v-expansion-panel title="Sources">
            <v-expansion-panel-text v-for="(source, n) in sources" :key="n">
                <!-- <RessourceLink :doc="findRessource(getSourceName(source))"  :title = "source.filename" /> -->
                <RessourceLink :doc="source"  :title = "`${source.filename} - ${source.discipline}`" />
                <span>
                    <span class = "theme" v-for="(theme, index) in source?.themes?.split(';')" :key="index">{{ theme }}</span>
                </span>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script setup>
import { computed, inject, onMounted } from 'vue';
import RessourceLink from '@/views/RessourceLink.vue';
// const configLinks = inject('configLinks')

// const getSourceName = (source) => source.metadata?.source.split("/").pop();
const getSourceName = (source) => source.filename;
// const findRessource = name => configLinks.value.find(doc => doc.name === name ) || { name, url: "#" }
const findRessource = name => { return { name, url: "#"} }

const props = defineProps({
    infos: {
        type: Object,
        required: true,
        default: {}
    }
});

const shownValue = computed(() => props.infos)

const sources = computed(() => shownValue.value.sources)

</script>


<style scoped>
.theme {
    background-color: rgb(0, 0, 145);
    color : white;
    border-radius: 4px;
    padding: 2px 6px;
    margin-right: 4px;
    font-size: 12px;
}
</style>

